<div class="hw-box-content">
  <div class="hw-header-wrap">
    <div class="row">
      <div class="col-12">
        <ul class="list-inline">
          <li class="align-top pt">
            <div class="form-check bold">
              <label class="form-check-label"> ActiveMQ Server : </label>
            </div>
          </li>
          <li class="align-top width-200px">
            <fn-select
              [labelKey]="'hostName'"
              [inputKey]="'hostName'"
              [optionList]="mqArray"
              [placeholder]="'Select HostName'"
              [(ngModel)]="selectMQ"
              [ngModelOptions]="{ standalone: true }"
            >
            </fn-select>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="hw-content" *ngIf="showMQ">
    <div class="row">
      <div class="col-9">
        <h3 class="hdColour">Queue Stats</h3>
      </div>
      <div class="col-3 text-right">
        <fn-button [type]="'success'" [btnClass]="'btn-sm btn-round'" [text]="'Refresh Statics'"
              (click)="refresh()"></fn-button>
      </div>
      <div class="row textColour" >
        <div class="col-6">
          <label><b>ActiveMQ Version : {{ brokerVersion }}</b></label
          >
        </div>
        <div class="col-6">
          <label><b>ActiveMQ UpTime : {{ uptime }}</b></label
          >
        </div>
      </div>
      <div class="row textColour">
        <div class="col-6">
          <label><b>ActiveMQ Memory Limit : {{ memoryLimit }} GB</b></label
          >
        </div>
        <div class="col-6">
          <label><b>ActiveMQ Memory Percent Usage : {{ memoryUsage }} %</b></label
          >
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" >
        <fn-table [config]='config' [rowMetaArray]='rowMetaArray' [dataArray]='mqDataArray' [pageSize]="15">
           <ng-template #customTempRef let-row>
                <i class="fn-global-refresh blue m-5" [ngClass]="{ refresh: isRefresh }"  title="Reset" (click)="refreshAction(row)"></i>
                <i class="fn-global-APK blue m-5" title="Purge" (click)="purgeMQQueue(row)"></i>
                <i class="fn-global-tasks blue m-5" title="Details" (click)="infoRowAction(row)"></i>
              </ng-template>  
        </fn-table>
      </div>
    </div>
  </div>
</div>
